function hashCell(ix: number, iy: number, iz: number): number {
  let h = (ix | 0) * 73856093;
  h ^= Math.imul(iy | 0, 19349663);
  h ^= Math.imul(iz | 0, 83492791);
  h ^= h >>> 13;
  h = Math.imul(h, 1274126177);
  h ^= h >>> 16;
  return (h >>> 0) / 0xffffffff;
}

function smoothstep(t: number): number {
  return t * t * (3 - 2 * t);
}

function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

export function noise3d(x: number, y: number, z: number): number {
  const ix = Math.floor(x);
  const iy = Math.floor(y);
  const iz = Math.floor(z);
  const fx = x - ix;
  const fy = y - iy;
  const fz = z - iz;

  const sx = smoothstep(fx);
  const sy = smoothstep(fy);
  const sz = smoothstep(fz);

  const c000 = hashCell(ix, iy, iz);
  const c100 = hashCell(ix + 1, iy, iz);
  const c010 = hashCell(ix, iy + 1, iz);
  const c110 = hashCell(ix + 1, iy + 1, iz);
  const c001 = hashCell(ix, iy, iz + 1);
  const c101 = hashCell(ix + 1, iy, iz + 1);
  const c011 = hashCell(ix, iy + 1, iz + 1);
  const c111 = hashCell(ix + 1, iy + 1, iz + 1);

  const x00 = lerp(c000, c100, sx);
  const x10 = lerp(c010, c110, sx);
  const x01 = lerp(c001, c101, sx);
  const x11 = lerp(c011, c111, sx);

  const y0 = lerp(x00, x10, sy);
  const y1 = lerp(x01, x11, sy);

  return lerp(y0, y1, sz) * 2 - 1;
}

export function fbm3d(
  x: number,
  y: number,
  z: number,
  octaves = 4,
  persistence = 0.5,
  lacunarity = 2.0
): number {
  let sum = 0;
  let amp = 1;
  let freq = 1;
  let maxAmp = 0;
  for (let i = 0; i < octaves; i++) {
    sum += noise3d(x * freq, y * freq, z * freq) * amp;
    maxAmp += amp;
    amp *= persistence;
    freq *= lacunarity;
  }
  return sum / maxAmp;
}
